// TODO for reviewers: The content and messaging across the new deployment pages
// (/deploy-anywhere/, /preset-on-prem/, and updated sub-pages) are a first-pass starting
// point. Copy, value props, and CTAs should be reviewed and refined by the marketing team
// before going live. In particular: hero headlines, feature descriptions, and FAQ answers.
import { SEOHead } from "components/SEO"
import { generateSoftwareApplicationSchema } from "utils/structuredData"
import BIToolPoweredByApacheSupersetSection from "components/pages/product/BIToolPoweredByApacheSupersetSection"
import GatedWhitepaperCTA from "components/GatedWhitepaperCTA"
import DeploymentSpectrumSection from "components/pages/deploy-anywhere/DeploymentSpectrumSection"
import HeroSection from "components/pages/deploy-anywhere/HeroSection"
import ProductGridSection from "components/pages/deploy-anywhere/ProductGridSection"
import SingleCTASection from "components/pages/deploy-anywhere/SingleCTASection"
import Layout from "components/ui/Layout"

function DeployAnywhere({ location: { pathname } }) {
  return (
    <Layout
      trackingName="Deploy Anywhere"
      pageName="deploy-anywhere"
      pagePath={pathname}
    >
      <HeroSection />
      <BIToolPoweredByApacheSupersetSection />
      <ProductGridSection />
      <DeploymentSpectrumSection />
      <GatedWhitepaperCTA
        label="Free Whitepaper"
        heading="The Enterprise Guide to Self-Hosted Superset"
        description="Learn how Preset-Certified Superset delivers enterprise-grade analytics on your infrastructure — covering deployment architecture, security, expert support, and more."
        buttonText="Download Whitepaper"
        pdfUrl="/documents/sales/PCS-Whitepaper.pdf"
        sourcePage="deploy-anywhere-whitepaper"
        trackingName="Download Whitepaper_Deploy Anywhere"
      />
      <SingleCTASection />
    </Layout>
  )
}

export function Head() {
  const schema = generateSoftwareApplicationSchema({
    name: "Preset",
    description:
      "Preset delivers enterprise Apache Superset across every deployment model — fully managed SaaS, managed private cloud, on-premises, and self-hosted — with consistent capabilities and expert support.",
    url: "https://preset.io/deploy-anywhere/",
  })

  return (
    <SEOHead
      title="Deploy Anywhere | Preset — Apache Superset for Every Environment"
      description="Run Preset however your infrastructure requires. Fully managed SaaS, managed private cloud, on-prem, or self-hosted — one platform, every deployment model."
      structuredData={schema}
    />
  )
}

export default DeployAnywhere
